import React from 'react';
import { Config } from './Config';

const MAX_CALENDAR_FARES_DIGITS = 4;

export const CurrencyUtils = {
    getRoundedAmount: (amount) => {
        return amount ? Math.ceil(amount) : 0;
    },

    shouldShowAmount: (amount) => {
        if (isNaN(amount)) {
            return false;
        }
        const digitCount = CurrencyUtils.getRoundedAmount(amount).toString().length;
        return digitCount <= MAX_CALENDAR_FARES_DIGITS;
    },

    getFormattedCalendarFares: (amount) => {
        const { currencyPosition, currencySymbol } = Config.get('i18n').currency;
        const roundedAmount = CurrencyUtils.getRoundedAmount(amount);
        const orderedDisplayAmount =
            currencyPosition === 'front'
                ? `${currencySymbol}${roundedAmount}`
                : `${roundedAmount}${currencySymbol}`;
        return CurrencyUtils.shouldShowAmount(roundedAmount) ? (
            <span dangerouslySetInnerHTML={{ __html: `${orderedDisplayAmount}` }} />
        ) : (
            <div className="odf-icon odf-icon-s odf-icon-more" style={{ display: 'block' }} />
        );
    },
};
